export default __webpack_public_path__ + "static/media/icon-single.8cca75b6.svg";